module.exports = __webpack_public_path__ + "static/media/semi.25008f60.png";